import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, queryParameters, renderRedirect } from "../module_auth/AuthService"
import { PaginationCustom } from "../component/common/PaginationCustom"
import { useNavigate } from "react-router-dom"
import { SearchInputBadge } from "../component/common/Badge"
import { JobTableRow } from './JobTableRow';
import { GridJob } from '../component/common/GridJob';
import { isValidSearchPage, sendGoogleAnalytics } from './common/BaseUtil';
import '../App.css'
import { useLocation } from "react-router-dom";

export function JobList() {
    const location = useLocation();

    const [premiumObjectList, setPremiumObjectList] = useState([]);
    const [objectList, setObjectList] = useState([]);
    const [gridObjectList, setGridObjectList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [cityList, setCityList] = useState([]);

    const navigate = useNavigate();

    //const queryParameters = new URLSearchParams(window.location.search)
    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    ////pagination

    ////handle search
    const [searchInput, setSearchInput] = useState("");
    const [showSearchInputBadge, setShowSearchInputBadge] = useState(false);

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)
        
        getCityList();

        //currentPage
        let currentPage
        if(!isValidSearchPage(page)){
            let localStoragePage = localStorage.getItem("page")
            currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
        } else {
            currentPage = page == "0" ? "1" : page
        }
        //end currentPage

        navigate("/job_list?page="  + currentPage);
        localStorage.setItem("page", currentPage)
        
        let url = basePort + '/get/search/jobs/' + currentPage
        let premiumUrl = basePort + '/get/premium/search/jobs'

        let activePageIndex = (currentPage-1)%2
        if(next != null){
            url = basePort + '/get/search/jobs/next/' + currentPage
            activePageIndex = (currentPage-1)%2
        } else if(previous != null) {
            url = basePort + '/get/search/jobs/previous/' + currentPage
            activePageIndex = (currentPage-1)%2
        }

        let searchInputCache = localStorage.getItem("searchInput") == null ? "" : localStorage.getItem("searchInput")
        const searchObject = {
            searchInput:searchInputCache,
        }

        fetch(premiumUrl, 
            {method:'post', headers, body:JSON.stringify(searchObject)})
                .then(response => response.json())
                .then(response => {
                    makeGridArray(response)

        }).catch(error => console.log(error))

        fetch(url, 
            {method:'post', headers, body:JSON.stringify(searchObject)})
                .then(response => response.json())
                .then(response => {
                    setObjectList(response.cardList)

                    ////pagination
                    setPageList(response.displayPages)
                    setLastPage(response.lastPage)
                    setActivePageIndex(activePageIndex)
                    ////pagination
    
                    if(searchInputCache != ""){
                        setSearchInput(searchInputCache)
                        setShowSearchInputBadge(true)
                        localStorage.setItem("searchInput", searchInputCache)
                    }
                    
        }).catch(error => console.log(error))
    }, []);

    function makeGridArray(objectList){
        let gridObjectList = []
        for(let i=0;i<objectList.length;i++){
            let gridArray = []
            let index = parseInt(i/4)
            if(i%4 === 0){
                if(objectList[i]){
                    gridArray.push(objectList[i])
                }
                if(objectList[i+1]){
                    gridArray.push(objectList[i+1])
                }
                if(objectList[i+2]){
                    gridArray.push(objectList[i+2])
                }
                if(objectList[i+3]){
                    gridArray.push(objectList[i+3])
                }
                gridObjectList.push(gridArray)
            }
        }
        setGridObjectList(gridObjectList)
    }

    function getCityList(){
        let url = basePort + '/get/config'
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
               setCityList(response.cityEntityList)
          }).catch(error => console.log(error))
    }

    function clickSubmit(event) {
        event.preventDefault();
        setRedirect(true)
    }

    function clickSearchSubmit(event) {
        const searchObject = {
            searchInput:searchInput,
        }
        let currentPage
        if(page == null){
            currentPage = localStorage.getItem("page")
        } else {
            currentPage = page
        }
        let url = basePort + '/get/search/jobs/' + currentPage
        fetch(url, 
        {method:'post', headers, body:JSON.stringify(searchObject)})
            .then(response => response.json())
            .then(response => {
                setObjectList(response.cardList)
            
                ////pagination
                setPageList(response.displayPages)
                setLastPage(response.lastPage)
                setActivePageIndex(activePageIndex)
                ////pagination

                setShowSearchInputBadge(true)
                localStorage.setItem("searchInput", searchInput)
        }).catch(error => console.log(error))
    }

    function handleInputSearch(event){
        setSearchInput(event.target.value)
        setShowSearchInputBadge(false)
    }

    function removeSearchInput(event){
        setSearchInput("")
        setShowSearchInputBadge(false)
        localStorage.setItem("searchInput", "")
    }

    return (
        <div>
            {renderRedirect(redirect, '/job_reg_select')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row" style={{display: 'flex'}}>
                            <div class="col-md-6 d-md-flex justify-content-xl-center align-items-xl-center justify-content-xxl-center">
                                <p class="d-flex justify-content-center justify-content-md-center align-items-xxl-center" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px', marginTop: '15px'}}>채용정보</p>
                            </div>
                            <div class="col-md-6 d-flex d-md-flex justify-content-center justify-content-md-center align-items-md-center"><button class="btn btn-primary btn-sm text-end" type="button" onClick={clickSubmit} style={{borderRadius:'5px'}}>등록</button></div>
                        </div>
                        {/* <div class="container" style={{textAlign: 'center', maxWidth: '700px', marginBottom: '10px'}}>
                            <div class="input-group"><input class="form-control" type="text" value={searchInput} onChange={handleInputSearch}/><button class="btn btn-secondary" type="button" onClick={clickSearchSubmit}>찾기</button></div>
                        </div>
                        <div class="container" style={{textAlign: 'center', width: '700px', marginBottom: '20px'}}>
                            <SearchInputBadge showSearchInputBadge={showSearchInputBadge} searchInput={searchInput} removeSearchInput={removeSearchInput}/>
                        </div> */}
                    </div>
                    
                    <div class="container">
                        <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a><span>프리미엄</span></a></li>
                        </ol>
                        {/* {premiumObjectList.map((object, index) => (
                            <JobCard object={object} index={index} cityList={cityList} key={index} returnTo={"/job_list"}/>
                        ))} */}

                        {gridObjectList.map((object, index) => (
                                <div class="row">
                                    <GridJob object={object} cityList={cityList}/>
                                </div>
                            ))
                        }
                        
                    </div>
                    <div class="container">
                        <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>일반</span></li>
                        </ol>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        {/* 반응형 테이블 및 css */}
                                        <th class="priority-1" style={{width: '50%'}}>제목</th>
                                        <th class="priority-2" style={{width: '10%'}} className="responsive-table-row">근무도시</th>
                                        {/* <th class="priority-3" style={{width: '10%'}} className="responsive-table-row">근무시간</th> */}
                                        <th class="priority-4" style={{width: '10%'}} className="responsive-table-row-date">등록일</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {objectList.map((object, index) => (
                                        <JobTableRow object={object} index={index} key={index} cityList={cityList}/>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <PaginationCustom 
                        lastPage={lastPage}
                        page={page}
                        pageList={pageList}
                        activePageIndex={activePageIndex}
                        url={'job_list'}
                    />
                    <div class="container" style={{textAlign: 'center', maxWidth: '700px', marginBottom: '10px'}}>
                        <div class="input-group"><input class="form-control" type="text" value={searchInput} onChange={handleInputSearch}/><button class="btn btn-secondary" type="button" onClick={clickSearchSubmit}>찾기</button></div>
                    </div>
                    <div class="container" style={{textAlign: 'center', width: '700px', marginBottom: '20px'}}>
                        <SearchInputBadge showSearchInputBadge={showSearchInputBadge} searchInput={searchInput} removeSearchInput={removeSearchInput}/>
                    </div>
                    </div>
                </section>
            </main>
        </div>
    );
}

export function JobCardLocal(object, index) {
      
    return (
        <div class="card" key={index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <h4 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold' }}>{object.objTitle}</h4>
                <h6 class="text-muted card-subtitle mb-2" style={{ fontFamily: 'Nanum Gothic' }}>회사:{object.cpName}</h6>
                <p class="card-text">{object.jobDetail.replace( /(<([^>]+)>)/ig, '')}</p>
                <button class="btn btn-outline-info" type="button">자세히</button>
            </div>
        </div> 
    );
}